import { observer } from 'mobx-react-lite'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { useCreditUsage } from 'hooks/useCreditUsage'
import { Text } from 'blaze-ui/Text/Text'

export const BrandVisualOptionCreditsLabel = observer(() => {
  const creditsEnabled = useFlipperFlag('credits_styles_videos')
  const { usageCosts } = useCreditUsage()
  const visualStylesCost = usageCosts?.visual_styles_credits_cost || 0
  const animatedImagesCost = usageCosts?.video_credits_cost || 0

  if (!creditsEnabled) return null

  return (
    <Text variant="secondary" color="var(--dark-60)">
      {animatedImagesCost} credits per video & {visualStylesCost} credits per photo
    </Text>
  )
})
